export interface IRequirementAlterModel {
    id?: string;
    container_size_type: any;
    condition: any;
    is_active: boolean;
    quantity: number;
    request?: string
}

export interface RequirementAlterError {
    container_size_type: string[];
    condition: string[];
    quantity: string[];
}

export class RequirementAlterModel {
    container_size_type: any;
    condition: any;
    is_active: boolean;
    quantity: number;

    error: RequirementAlterError;

    constructor() {
        this.container_size_type = null;
        this.condition = null;
        this.is_active = true;
        this.quantity = null;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            container_size_type: [],
            condition: [],
            quantity: []
        }
    }

    setRequirementPayload(data) {
        this.container_size_type = data.container_size_type;
        this.condition = data.condition;
        this.quantity = data.quantity;
    }

    getRequirementData(): IRequirementAlterModel {
        return {
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
            is_active: this.is_active,
            quantity: this.quantity
        }
    }
}